const addRowIndex = <T>(value: ReadonlyArray<T>): ReadonlyArray<T & { rowIndex: number }> =>
  value.map((it, index) => ({
    ...it,
    rowIndex: index,
  }))

export default addRowIndex
